import { createGlobalStyle } from 'styled-components';

import bulma from 'bulma/css/bulma.css';

export default createGlobalStyle`
  ${bulma}
`;
